module.exports = __webpack_public_path__ + "img/kh3.eceed0aa.png";